/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentCreateMutationRequest, ContentCreateMutationResponse } from "../models/ContentCreate";

export function getContentCreateUrl() {
  const res = { method: 'POST', url: `/contents` as const }  
  return res
}

/**
 * @summary Create content
 * {@link /contents}
 */
export async function contentCreate(data: ContentCreateMutationRequest, config: Partial<RequestConfig<ContentCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentCreateMutationResponse, ResponseErrorConfig<Error>, ContentCreateMutationRequest>({ method : "POST", url : getContentCreateUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}